import { useUiLanguage } from "@/i18n/useUiLanguage";
import { systemText, tr } from "@/i18n/copy";
import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { getPushDeviceState } from "@/pwa";
import { Button } from "@/components/ui/button";

export default function PushTestButton({ relationshipId = null, enabled = false }) {
  useUiLanguage();
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const send = async () => {
    if (busy) return;
    setBusy(true); setError(""); setMessage("");
    try {
      const state = await getPushDeviceState(api, relationshipId);
      if (!state.device_active || !state.subscription?.endpoint) throw new Error(tr("Attiva le notifiche su questo dispositivo prima di provarle."));
      const query = relationshipId ? `?relationship_id=${encodeURIComponent(relationshipId)}` : "";
      const result = await api.post(`/push/test${query}`, { endpoint: state.subscription.endpoint });
      if (!result?.sent) throw new Error(tr("La notifica di prova non è stata inviata. Riprova l’attivazione."));
      setMessage(tr("Prova inviata. Controlla che compaia tra le notifiche del dispositivo, anche nel Centro notifiche. Se non appare, verifica le impostazioni notifiche e la modalità Non disturbare."));
    } catch (failure) { setError(errMsg(failure)); }
    finally { setBusy(false); }
  };
  return <div className="space-y-2" data-testid="push-self-test"><Button type="button" variant="outline" disabled={busy || !enabled} onClick={send}>{busy ? tr("Invio prova…") : tr("Invia notifica di prova")}</Button>{message && <p role="status" className="text-sm text-emerald-600">{message}</p>}{error && <p role="alert" className="text-sm text-destructive">{systemText(error)}</p>}</div>;
}
